module.exports = __webpack_public_path__ + "img/budaya.00274aa9.png";